"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledContainer = exports.SimpleContainer = exports.StyledAppointmentIdContainer = exports.LayoutBody = exports.DesktopMainContent = exports.MobileContainer = exports.CancelPageMobileMainContent = exports.MobileMainContent = exports.SidebarContainer = exports.DesktopContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const breakpoints_1 = require("../../lib/constants/breakpoints");
const framer_motion_1 = require("framer-motion");
exports.DesktopContainer = styled_1.default.div `
  display: flex;
  flex-direction: row;
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_large')};
  gap: ${(0, ui_theme_1.fromTheme)('spacing_xxlarge')};
  padding: 0 ${(0, ui_theme_1.fromTheme)('spacing_large')} ${(0, ui_theme_1.fromTheme)('spacing_medium')};
`;
exports.SidebarContainer = styled_1.default.div `
  display: flex;
  // setting max width on sidebar
  max-width: ${breakpoints_1.SIDEBAR_WIDTH};
  line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
  position: sticky;
  top: 0;
  height: fit-content;
`;
exports.MobileMainContent = styled_1.default.section `
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.isErrorOrRescheduled
    ? (0, ui_theme_1.fromTheme)('spacing_xlarge')
    : (0, ui_theme_1.fromTheme)('spacing_medium')};
  padding-bottom: ${(props) => props.isErrorOrRescheduled
    ? (0, ui_theme_1.fromTheme)('spacing_xlarge')
    : (0, ui_theme_1.fromTheme)('spacing_xxlarge')};

  > div > div > section {
    margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  }
`;
exports.CancelPageMobileMainContent = (0, styled_1.default)(exports.MobileMainContent) `
  > div > div > section {
    margin-bottom: 0;
  }
`;
exports.MobileContainer = styled_1.default.div `
  display: flex;
  flex-direction: column;
  padding: ${(0, ui_theme_1.fromTheme)('spacing_large')};
  > .scheduling-help-banner {
    line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
  }
`;
exports.DesktopMainContent = styled_1.default.div `
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_xxlarge')};
  width: 80%;
`;
exports.LayoutBody = (0, styled_1.default)(framer_motion_1.motion.div) `
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  position: relative;
  flex-basis: 100%;

  @media (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_medium')}) {
    flex-direction: row;
  }
`;
exports.StyledAppointmentIdContainer = styled_1.default.div `
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
`;
exports.SimpleContainer = styled_1.default.div `
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_large')};
  padding: 0 ${(0, ui_theme_1.fromTheme)('spacing_large')};
`;
exports.StyledContainer = styled_1.default.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
  gap: ${(0, ui_theme_1.fromTheme)('spacing_large')};
`;
//# sourceMappingURL=styles.js.map